import api from './api';

const purchaseRequisitionService = {
  // Get all purchase requisitions
  getAllPurchaseRequisitions: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.priority) queryParams.append('priority', params.priority);
      if (params.requester) queryParams.append('requester', params.requester);
      if (params.project) queryParams.append('project', params.project);
      if (params.search) queryParams.append('search', params.search);

      const queryString = queryParams.toString();
      const url = `/purchase-requisition${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching purchase requisitions:', error);
      throw error;
    }
  },

  // Get purchase requisition by ID
  getPurchaseRequisitionById: async (id) => {
    try {
      const response = await api.get(`/purchase-requisition/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching purchase requisition:', error);
      throw error;
    }
  },

  // Get next requisition number
  getNextRequisitionNumber: async () => {
    try {
      const response = await api.get('/purchase-requisition/number/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next requisition number:', error);
      throw error;
    }
  },

  // Create purchase requisition
  createPurchaseRequisition: async (requisitionData) => {
    try {
      const response = await api.post('/purchase-requisition', requisitionData);
      return response.data;
    } catch (error) {
      console.error('Error creating purchase requisition:', error);
      throw error;
    }
  },

  // Update purchase requisition
  updatePurchaseRequisition: async (id, requisitionData) => {
    try {
      const response = await api.put(`/purchase-requisition/${id}`, requisitionData);
      return response.data;
    } catch (error) {
      console.error('Error updating purchase requisition:', error);
      throw error;
    }
  },

  // Delete purchase requisition
  deletePurchaseRequisition: async (id) => {
    try {
      const response = await api.delete(`/purchase-requisition/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting purchase requisition:', error);
      throw error;
    }
  },

  // Submit requisition for approval
  submitForApproval: async (id) => {
    try {
      const response = await api.put(`/purchase-requisition/${id}/submit`);
      return response.data;
    } catch (error) {
      console.error('Error submitting purchase requisition:', error);
      throw error;
    }
  },

  // Get purchase requisition statistics
  getPurchaseRequisitionStats: async () => {
    try {
      const response = await api.get('/purchase-requisition/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching purchase requisition statistics:', error);
      throw error;
    }
  }
};

export default purchaseRequisitionService;

